import { useState } from "react";
import { CloseIcon, DeleteIcon } from "../../assets/icons";
import { useConfirmPopup } from "../popup/confirmPopup/confirmPopup";
import { Image } from "../image/image";
import classNames from "classnames";
import { Video } from "../video/video";

import styles from "./imageGrid.module.css";

export const ImageGrid = ({
    className,
    images = [],
    imageSizing = true,
    onDelete = null,
    onDeleteItem = null,
    deleteEntityName = "изображение",
}) => {
    const [current, setCurrent] = useState(0);
    const [visible, setVisible] = useState(false);
    const [deletingElement, setDeletingElement] = useState(null);

    const currentItem = images?.[current];
    const currentType = currentItem?.type || "image";

    const resolveDeleteEntityName = () => {
        if (typeof deleteEntityName === "function") {
            return deleteEntityName(deletingElement) || "";
        }
        return deleteEntityName;
    }

    const [DeletePopup, openDeletePopup] = useConfirmPopup(
        "Подтвердите действие",
        `Вы уверены, что хотите удалить ${resolveDeleteEntityName()}?`,
        () => {
            if (!deletingElement) return;
            if (onDeleteItem) return onDeleteItem(deletingElement);
            return onDelete(deletingElement.id);
        }
    )

    return (
        <div className={classNames(styles.images, className)}>
            {
                imageSizing &&
                <div className={classNames(styles.big_picture, { [styles.active]: visible })}>
                    {currentType === "video" ? (
                        <Video src={currentItem?.src} objectFit="contain" previewOnly />
                    ) : (
                        <Image src={currentItem?.src} objectFit="contain" />
                    )}
                    <CloseIcon className={styles.close_icon} onClick={() => setVisible(false)} />
                </div>
            }
            {
                images.map((item, i) =>
                    <div className={styles.image} key={`${item.type || "image"}-${item.id}`} onClick={() => {
                        setCurrent(i);
                        setVisible(true);
                    }}>
                        {((item.type || "image") === "video") ? (
                            <>
                                <Video src={item.src} objectFit="cover" className={styles.image_preview} previewOnly />
                                <div className={styles.play_badge} />
                            </>
                        ) : (
                            <Image src={item.src} objectFit="cover" className={styles.image_preview} />
                        )}
                        {
                            (onDelete !== null || onDeleteItem !== null) &&
                            <DeleteIcon
                                className={styles.image_delete}
                                onClick={e => {
                                    e.stopPropagation();
                                    setDeletingElement(item);
                                    openDeletePopup();
                                }}
                            />
                        }
                    </div>
                )
            }

            {DeletePopup}
        </div>
    );
}